// Where each page was left, in memory: Back and a tab bar tap put it back (ScrollToTop in App.jsx). By history entry for
// Back and by path for the tabs, which push a new entry each time. Nothing is written to the device
const MAX = 120;
const saved = new Map();

const set = (key, y) => {
  saved.delete(key);
  saved.set(key, Math.max(0, Math.round(y)));
  while (saved.size > MAX) saved.delete(saved.keys().next().value);
};

export const rememberScroll = (entryKey, pathname, y) => {
  set(`entry:${entryKey}`, y);
  set(`path:${pathname}`, y);
};

export const scrollOfEntry = (entryKey) => saved.get(`entry:${entryKey}`) ?? null;
export const scrollOfPath = (pathname) => saved.get(`path:${pathname}`) ?? null;

export const clearScrollMemory = () => saved.clear();

/** The history state of a tab bar tap: a tab comes back as it was left, as a native tab bar's does. */
export const TAB_NAVIGATION = { tabNavigation: true };

export const isTabNavigation = (state) => state?.tabNavigation === true;
